/* 색상 추가 및 변경 하면 안 돼요! */
export const PROFILE_COLORS = [
  '#41AC4D',
  '#9375DB',
  '#315FC7',
  '#8EC93D',
  '#D8CA2C',
  '#46B2AF',
  '#377538',
  '#623FB3',
  '#2C4170',
  '#668A33',
  '#3A7977',
];

// 현재 결과표 컬러 시스템을 따르고 있음
// 2023년 상반기 ATS 브랜딩 때에 컬러 팔레트 바뀔 여지 있음

export const COLORS = {
  // basic
  white: '#FFFFFF',
  gray50: '#F8F9FA',
  gray80: '#6A7081',
  black: '#000000',
  guide: '#00C8FF',
  error: '#f0464f',
  warning: '#ffc82a',

  // gray
  gray100: '#F1F3F5',
  gray200: '#E9ECEF',
  gray300: '#DEE2E6',
  gray400: '#CED4DA',
  gray500: '#ADB5BD',
  gray600: '#868E96',
  gray700: '#495057',
  gray800: '#343A40',
  gray900: '#212529',

  // red
  red100: '#FFE3E3',
  red500: '#FF6B6B',
  red600: '#FA5252',
  red900: '#C92A2A',

  // violet
  violet50: '#F3F0FF',
  violet100: '#E5DBFF',
  violet200: '#D0BFFF',
  violet300: '#B197FC',
  violet400: '#9775FA',
  violet500: '#845EF7',
  violet600: '#7950F2',
  violet700: '#7048E8',
  violet800: '#6741D9',
  violet900: '#5F3DC4',

  // blue
  blue50: '#E7F5FF',
  blue100: '#D0EBFF',
  blue200: '#A5D8FF',
  blue300: '#74C0FC',
  blue400: '#4DABF7',
  blue500: '#339AF0',
  blue600: '#228BE6',
  blue700: '#1C7ED6',
  blue800: '#1971C2',
  blue900: '#1864AB',

  // cyan
  cyan50: '#E3FAFC',
  cyan100: '#C5F6FA',
  cyan200: '#99E9F2',
  cyan300: '#66D9E8',
  cyan400: '#3BC9DB',
  cyan500: '#22B8CF',
  cyan600: '#15AABF',
  cyan700: '#1098AD',
  cyan800: '#0C8599',
  cyan900: '#0B7285',

  // green
  green50: '#EBFBEE',
  green100: '#D3F9D8',
  green200: '#B2F2BB',
  green300: '#8CE99A',
  green400: '#69DB7C',
  green500: '#51CF66',
  green600: '#40C057',
  green700: '#37B24D',
  green800: '#2F9E44',
  green900: '#2B8A3E',

  // lime
  lime50: '#F4FCE3',
  lime100: '#E9FAC8',
  lime200: '#D8F5A2',
  lime300: '#C0EB75',
  lime400: '#A9E34B',
  lime500: '#94D82D',
  lime600: '#82C91E',
  lime700: '#74B816',
  lime800: '#66A80F',
  lime900: '#5C940D',

  // yellow
  yellow50: '#FFF9DB',
  yellow100: '#FFF3BF',
  yellow200: '#FFEC99',
  yellow300: '#FFE066',
  yellow500: '#FCC419',
  yellow600: '#FAB005',
  yellow700: '#F59F00',
  yellow800: '#F08C00',
  yellow900: '#E67700',

  // teal
  teal50: '#E6FCF5',
  teal100: '#C3FAE8',
  teal200: '#96F2D7',
  teal300: '#63E6BE',
  teal400: '#38D9A9',
  teal500: '#20C997',
  teal600: '#12B886',
  teal700: '#0CA678',
  teal800: '#099268',
  teal900: '#087F5B',
} as const;
